module.exports = __webpack_public_path__ + "static/media/accordion-up-violet.aada7b2b.svg";